import { FC, useMemo } from "react";
import { useSelector } from "react-redux";

import { IPickerListItem, Picker } from "@livechat/design-system-react-components";

import { Filter } from "constants/filters";
import { sortAgents } from "helpers/agent";
import { IAgent, selectAgents } from "store/entities/agents";

import { createAgentOption } from "../agent-filter/agent-filter";
import { createRemovedFollowerOption } from "../helpers";
import { IFilterConfig, IFilterUpdate } from "../interfaces";
import { withFilterBase } from "../withFilterBase";

interface IProps {
  filterValues: string[];
  agents: IAgent[];
  currentAgent: IAgent;
  filterConfig: IFilterConfig;
  onChange(filterUpdate: IFilterUpdate<string[] | null>): void;
  onClose(): void;
}

const FollowersFilterSingle: FC<IProps> = props => {
  const { agents, currentAgent, filterValues, onChange } = props;
  const agentsById = useSelector(selectAgents);

  const handleChange = (selectedItem: IPickerListItem[] | null): void => {
    const isEmpty = !selectedItem || selectedItem.length === 0;

    onChange({
      name: Filter.Followers,
      value: isEmpty ? null : (selectedItem?.map(item => item.key) ?? []),
    });
  };

  const agentOptions = useMemo(
    () => agents.sort(sortAgents("name", false, currentAgent)).map(agent => createAgentOption(agent, currentAgent)),
    [agents, currentAgent]
  );

  const selectedAgents = useMemo(
    () =>
      filterValues?.map(agentId => {
        const agent = agentsById[agentId];

        return agent ? createAgentOption(agent, currentAgent) : createRemovedFollowerOption(agentId);
      }),
    [agents, filterValues]
  );

  return (
    <Picker
      id="followers-filter"
      openedOnInit
      placeholder="Search…"
      options={agentOptions}
      type="multi"
      selected={selectedAgents}
      onSelect={handleChange}
      hideClearButton
      clearSearchAfterSelection
    />
  );
};

export default withFilterBase(FollowersFilterSingle);
